import React, { ReactNode, useContext } from 'react'
import { EUROPE_REGIONS } from 'constants/config/region'
import { hasPassedWalledGarden } from 'selectors/accountSelectors'
import { useAppSelector } from 'hooks/reduxHooks'
import { isInMobileApp } from 'lib/web/deviceUtils'
import GeoContext from 'contexts/geoContext'
import { OptimizelyExperiments } from 'constants/optimizely'
import useOptimizelyExperiment from 'hooks/Optimizely/useOptimizelyExperiment'

const walledRegions = new Set([
  ...EUROPE_REGIONS.values(),
  'AU',
  'NZ',
])
interface Props {
  wall?: ReactNode
  bypassWall?: boolean
  children: React.ReactNode
}

function SoftOfferPageWalledGarden({
  wall,
  bypassWall,
  children,
}: Props) {
  const { currentRegionCode } = useContext(GeoContext)
  const utmMedium = useAppSelector(state => state.utm.medium)
  const isMobileApp = useAppSelector(state => isInMobileApp(state.config.rawUserAgentString))
  const isSofterWalledGardenEnabled = !!useOptimizelyExperiment(OptimizelyExperiments.croSofterWalledGardenEnabled)
  const passedWalledGarden = useAppSelector(hasPassedWalledGarden)
  const isWallGardened = walledRegions.has(currentRegionCode)

  const bypassWalledGarden =
    bypassWall ||
    isMobileApp ||
    utmMedium === 'email' ||
    utmMedium === 'push' ||
    utmMedium === 'sms'

  const showWall = isWallGardened && isSofterWalledGardenEnabled && !(bypassWalledGarden || passedWalledGarden)

  if (showWall) return <>{wall}</>

  return <>{children}</>
}

export default SoftOfferPageWalledGarden
